import { render, staticRenderFns } from "./TemplateVariableWidget.vue?vue&type=template&id=1f5233e5&"
import script from "./TemplateVariableWidget.vue?vue&type=script&lang=ts&"
export * from "./TemplateVariableWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports